import { createContext, useContext, useEffect, useState } from "react";
import { customerApi, formatApiErrorDetail } from "@/lib/api";

const CustomerAuthContext = createContext(null);

export function CustomerAuthProvider({ children }) {
  const [customer, setCustomer] = useState(null); // null = checking, false = logged out, obj = logged in
  const token = localStorage.getItem("gysumo_customer_token");

  useEffect(() => {
    if (!token) {
      setCustomer(false);
      return;
    }
    customerApi
      .get("/customer/me")
      .then(({ data }) => setCustomer(data))
      .catch(() => {
        localStorage.removeItem("gysumo_customer_token");
        setCustomer(false);
      });
  }, [token]);

  const login = async (email, password) => {
    try {
      const { data } = await customerApi.post("/customer/login", { email, password });
      localStorage.setItem("gysumo_customer_token", data.token);
      setCustomer(data.customer);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatApiErrorDetail(e.response?.data?.detail) || e.message, status: e.response?.status };
    }
  };

  const register = async (name, email, password) => {
    try {
      const { data } = await customerApi.post("/customer/register", { name, email, password });
      return { ok: true, ...data };
    } catch (e) {
      return { ok: false, error: formatApiErrorDetail(e.response?.data?.detail) || e.message };
    }
  };

  const logout = () => {
    localStorage.removeItem("gysumo_customer_token");
    setCustomer(false);
  };

  return (
    <CustomerAuthContext.Provider value={{ customer, login, register, logout }}>
      {children}
    </CustomerAuthContext.Provider>
  );
}

export const useCustomerAuth = () => useContext(CustomerAuthContext);
